// a simple script for Form inputs to add empty placeholders where placeholders do not exist
// this is important for SA brand Material v3 style inputs alignment.

import Component from './Component';

export default class Form extends Component {

  load() {
    // console.log('Form loaded');
    this.initForm();
    this.replaceRecaptchaText();
    // this.doReplaceRecaptchaText();
    super.load();
  }

  initForm() {

    document.querySelectorAll("input[type='text']:not([placeholder])").forEach(input => {
      input.setAttribute("placeholder", " ");
    });

  }

  // doReplaceRecaptchaText() {
  //   // document.addEventListener('load', this.waitTime);
  //   // this.waitTime();
  //   this.replaceRecaptchaText();
  // }

  // waitTime() {
  //   // 1000 = 1 second
  //   setTimeout(this.replaceRecaptchaText, 1000);
  // }

  replaceRecaptchaText() {
    // console.log('replaceRecaptchaText()');

    // The exact text content to find.
    // This text should be entered in the reCAPTCHA field "helptext".
    const searchText = "GOOGLERECAPTCHA";

    // The replacement HTML content
    const replacementHtml = `
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
  `;

    // XPath expression to find any element whose direct text node equals searchText
    const xpathExpression = `//*[text()='${searchText}']`;
    // //*[@id="bff4785b-a844-417a-8a74-1e6c1487eb72"]/div/div[2]/div[6]/div/span

    // Use document.evaluate to find the element
    const result = document.evaluate(xpathExpression, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    const elementToReplace = result.singleNodeValue; // Get the first matching element

    if (elementToReplace) {
      // console.log("Found element:", elementToReplace);
      elementToReplace.innerHTML = replacementHtml; // Replace its content
    } else {
      console.log(`Element with exact text "${searchText}" not found.`);
    }
  }

}
